import { TUserState } from "./user.types";
import { LocalStorageKeys } from "../../constants";

const token = localStorage.getItem(LocalStorageKeys.ACCESS_TOKEN);

export const initialState: TUserState = {
  user: null,
  loading: false,
  loaded: false,
  error: null,
  token,
  amazonAccount: {
    shouldShowModal: false,
  },
};
